import React from 'react';
import FeatureReminderModal from './FeatureReminderModal';

type TermsUpdateReminderProps = {
  isVisible: boolean;
  onPressContinue: () => void;
};

const TermsUpdateReminder: React.FC<TermsUpdateReminderProps> = ({
  isVisible,
  onPressContinue
}) => (
  <FeatureReminderModal
    testId="terms-update-reminder"
    isVisible={isVisible}
    onPressContinue={onPressContinue}
    title="Heads-up! We've refreshed our Terms."
    description={
      <>
        We&apos;ve simplified some sections and clarified how payments and
        refunds work — all to make things easier for you.
        <br />
        <br />
        <a
          href="https://www.bouncelife.com/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary-400 hover:text-primary-500 underline"
        >
          https://www.bouncelife.com/terms
        </a>
      </>
    }
  />
);

export default TermsUpdateReminder;
